/*jshint esversion: 6 */

import {
  appConfig
} from './session';

import {
  sysInfo
} from './sym';

import {
  getAjaxOptions
} from './core';

import {
  ajax
} from './http';

export function getPaymentQueueId (payInfo) {
  payInfo.currencyId = sysInfo.currencyId;

  const
    body = JSON.stringify(payInfo),
    options = getAjaxOptions('POST', body);

  return ajax('api/rgn/' + payInfo.regionId + '/payqueue', options);

  // return ajax('api/payqueue/?accountId=' + guestInfo.accountId + '&amount=' + amountDue + '&currencyId=' + sysInfo.currencyId, options);

}

// export function createCheckout (guestInfo, queueId) {
export function createCheckout (checkoutInfo) {
  const
    options = getOptions('POST', getPublicKey(), true),
    url = appConfig.paymaya.apiHost + '/checkout/v1/checkouts',
    backUrl = window.location.href;

  // let
  //   itemName,
  //   amountDue;

  let
    regionId = checkoutInfo.regionId,
    queueId = checkoutInfo.queueId,
    itemName = 'Download Documents',
    amountDue = checkoutInfo.amountDue;

  // if (guestInfo.resStatusId < 4 ) {
  //   itemName = 'Advance Deposit - ' + sysInfo.siteShortName;
  //   amountDue = guestInfo.depositRequired;
  // } else {
  //   itemName = 'Hotel Bill - ' + sysInfo.siteShortName;
  //   amountDue = guestInfo.binPersonal;
  // }

  let body = {
    // requestReferenceNumber: queueId.toString(),
    requestReferenceNumber: regionId.toString() + '-' + queueId.toString(),

    buyer: {
      lastName: checkoutInfo.lastName,
      firstName: checkoutInfo.firstName,
       middleName: checkoutInfo.middleName
    },

    totalAmount: {
      value: amountDue,
      currency: sysInfo.currencyId
    },

    items: [
      {
        name: itemName,
        totalAmount: {
          value: amountDue
        }
      }
    ],

    redirectUrl: {
      success: backUrl,
      failure: backUrl,
      cancel: backUrl
    }

  };

  options.body = JSON.stringify(body);

  return ajax(url, options, false);
}

export function getWebhooks () {
  const
    options = getOptions('GET', getSecretKey(), false),
    url = appConfig.paymaya.apiHost + '/checkout/v1/webhooks';

  return ajax(url, options, false);
}

export function registerWebhook (webhookName) {
  const
    options = getOptions('POST', getSecretKey(), true),
    url = appConfig.paymaya.apiHost + '/checkout/v1/webhooks';

  let body = {
    name: webhookName,
    callbackUrl: appConfig.paymaya.webhookUrl
  };

  options.body = JSON.stringify(body);

  return ajax(url, options, false);
}

export function deleteWebhook (id) {
  const
    options = getOptions('DELETE', getSecretKey(), false),
    url = appConfig.paymaya.apiHost + '/checkout/v1/webhooks/' + id;

  return ajax(url, options, false);
}

function getSecretKey () {
  return 'Basic ' + btoa(appConfig.paymaya.secretKey) + ':';
}

function getPublicKey () {
  return 'Basic ' + btoa(appConfig.paymaya.publicKey) + ':';
}

function getOptions (method, apiKey, contentTypeFlag = false) {
  const options = {
    method: method,
    headers: {
      Authorization: apiKey,
      Accept: 'application/json'
    },
  };

  if (contentTypeFlag) {
    options.headers['Content-Type'] = 'application/json';
  }

  return options;
}